//
//
//
//
//
//

export default {
  name: 'app',
  data(){
    return {
      
    }
  },
  created() {
    
  },
  mounted() {
    
  },
  methods:{
  
  },
}



// WEBPACK FOOTER //
// ./src/App.vue